import {
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  ViewChild,
} from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgxPaginationModule } from "ngx-pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { BaseComponent } from "../../base/base.component";
import { FunctionService } from "../../services/function.service";
import { ActivatedRoute, Router } from "@angular/router";
import {
  IDropdownSettings,
  NgMultiSelectDropDownModule,
} from "ng-multiselect-dropdown";
import { catchError, forkJoin, Observable, of, Subscription } from "rxjs";
import {
  ColumnCustomizeComponent,
  TableColumn,
} from "../column-customize/column-customize.component";
import { OrderByPipe } from "../../base/order-by.pipe";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ErrorHelperService } from "../../services/error-helper.service";
import { NotificationService } from "../../services/notification.service";
import { Carrier } from "../../interfaces/anagraphic.interfaces";
import { ParcelMapComponent } from "./parcel-map/parcel-map.component";
import { ShipmentManagementService } from "../../services/shipment-management.service";
import SignaturePad from "signature_pad";
import { OnDestroy } from "@angular/core";
import { TourRouting } from "../../interfaces/TourRouting.interfaces";
import {
  ParcelFilterOptions,
  ParcelSearchFilters,
} from "../../interfaces/overview-parcels.interfaces";
import { OverviewParcelsService } from "../../services/overview-parcels.service";

export interface ComParcel {
  parcelComplementaryId: number;
  parcelComplementaryCode: string;
  parcelComplementaryBrandCode: string;
  parcelComplementaryName: string;
  parcelComplementaryType: string;
  parcelComplementaryValueNumber: number;
  parcelComplementaryValueText: string;
  parcelComplementaryValueDate: string;
  parcelComplementaryValueClob: string;
  parcelComplementaryStatus:
    "EXECUTED" | "PLANNED" | "ERROR" | "IN_PROGRESS" | string;
  parcelComplementaryCreatedAt: string;
  parcelComplementaryWaybillCode: string;
  parcelId: number;
  parcelComplementaryOriginalLatitude: number;
  parcelComplementaryOriginalLongitude: number;
  warehouseCode: string;
  dealerCode: string;
  parcelComplementaryEventType: string;
  parcelComplementaryEventStatus: string;
  carrierCode: string;
  externalTripCode: string;
  parcelComplementaryWarehouseFrom: string;
  parcelComplementaryWarehouseTo: string;
  parcelComplementaryDealerFrom: string;
  parcelComplementaryDealerTo: string;
  parcelComplementaryEventStart: string;
  parcelComplementaryEventEnd: string;
  parcelComplementaryCarrierCode: string;
  parcelComplementaryJustificationId: number;
  parcelComplementaryJustificationComment: string;
  parcelComplementarySequence: number;
  parcelComplementaryLoadingListId: number;
  loadingListCode: string;
  loadingListCarrierCode: string;
  carrierCodeDefaultGroup: string;
  parcelComplementaryTourRoutingId?: number;
  parcelComplementaryTripCode?: string;
}

export interface ViewTrackings {
  trackingWarehouseCode: string;
  trackingCreatedAt: string;
  rightedZone: string;
  tpLastMile: string;
  warehouseNameTracking: string;
  warehouseNameRightedZone: string;
}

export interface ViewParcels {
  parcelWaybillCode: string;
  parcelCode: string;
  parcelDate: string;
  parcelDeliveryDate: string;
  parcelEstimatedDeliveryDate: string;
  parcelDealerCode: string;
  dealerName: string;
  dealerOperatingAddressStreet: string;
  dealerOperatingAddressCity: string;
  dealerLatitude: number;
  dealerLongitude: number;
  parcelDescription: string;
  parcelDeliveryType: string;
  parcelWeight: number;
  parcelVolume: number;
  parcelBarcode: string;
  parcelTrackingNumber: string;
  parcelLatitude: number;
  parcelLongitude: number;
  parcelNotifiedStatus: string;
  parcelDeliveryStatus: string;
  parcelModifyManual: string;
  trackings: ViewTrackings[];
  distanceInMeters: number;
  coordinatesInRange: string;
  parcelWaybillCarrierCode: string;
  parcelWaybillCarrierName: string;
  parcelWaybillOriginLocation: string;
  parcelWaybillLastMileOrigin: string;
  parcelWaybillDeliveryMethod: string;
  parcelRegionCode: string;
  parcelRegionName: string;
  showTrackings?: boolean;
  parcelWaybillDeliveryType: string;
  parcelDeliveryReason: string;
  parcelOnTime: string;
  parcelOriginalDeliveryDate: string;
  parcelOriginalLatitude: number;
  parcelOriginalLongitude: number;
  parcelDeliveryDateIsForced: string;
  parcelDeliveryDateIsUpdated: string;
  parcelDeliveryCoordinatesIsForced: string;
  parcelDeliveryCoordinatesIsUpdated: string;
  parcelWaybillLastKnownLocation: string;
  parcelBrandCode: string;
  parcelClientCode: string;
  brandName: string;
  clientName: string;
  minutesDelay: number | null;
  waybillScheduleType: string;
  distanceOriginalInMeters: number;
  parcelJustificationId: number;
  parcelJustificationComment: string;
  parcelWaybillLoadingBay: string;
  showComParcels?: boolean;
  // stato del caricamento delle tappe, per singola riga
  loadingComParcels?: boolean;
  errorLoadingComParcels?: boolean;
  comParcels: ComParcel[];
  parcelWaybillStatus: string;
  isRoutingPresent: string;
  parcelCurrentWarehouse: string;
  activeTab?: "tracking" | "map";
  parcelWaybillMaximumRange: number;
  parcelWarehouseExternalCode: string;
  parcelDetailStatus: string;
  tourRoutingExternal: string;
  parcelOriginalWaybillCode: string;
  parcelHasMisrouting: string;
  isOrphan?: boolean;
  waybillDdtAttachments: string;
  isRestrictedClient: string;
  waybillShipmentCode: string;
  clientRequestSignature?: string;
  parcelType?: string;
  parcelPalletType?: string;
  parcelPalletDescription?: string;
  isBigOrder?: boolean;
  parcelDeliveryChangeCutoffDate?: string;
  parcelDeliveryChangeCutoffCountdown?: string;
  parcelDeliveryChangeCutoffExpired?: boolean;
  parcelDeliveryChangeCutoffWarning?: boolean;
  parcelNote?: string;
  waybillAddressAlias?: string;
  clientIsPersonalJustifications?: string;
  waybillExternalWaybillCode?: string;
  parcelIsJustificationSent?: string;
  waybillCarriersSentEmails?: string;
  waybillCarriersSentDate?: string;
  parcelLastComplementaryJustificationId: number;
  parcelLastComplementaryJustificationComment?: string;
}

interface Warehouse {
  warehouseCode: string;
  warehouseName?: string;
  warehouseShortName?: string;
  warehouseType?: string;
}

interface Justification {
  justificationId: number;
  justificationName?: string;
  justificationClientCode?: string;
}

// Risposta di GET /tracking/justifications/allowed
interface AllowedJustificationsGroup {
  clientCode: string | null;
  clientName: string | null;
  justifications: {
    justificationId: number;
    justificationCode: string;
    justificationName: string;
  }[];
}

interface JustificationCodeGroup {
  title: string;
  codes: { code: string; name: string }[];
}

// Intestazioni attese dal backend nella riga 1 del file di import (POST /tracking/import-excel-justifications)
const IMPORT_JUSTIFICATIONS_HEADERS = [
  "Codice collo",
  "Codice giustifica",
  "Commento giustifica",
];

interface Client {
  clientCode: string;
  clientName?: string;
  clientIsPersonalJustifications?: string;
}

interface Dealer {
  dealerCode: string;
}

// Voce di POST /tracking/dealers/options (dealer dei clienti dell'utente, solo i campi della tendina)
interface DealerAnagraphic {
  dealerCode: string | null;
  dealerName: string | null;
  dealerOperatingAddressCity: string | null;
}

// Voce di GET /tracking/regions
interface Region {
  regionCode: string;
  regionName?: string;
}

interface Brand {
  brandCode: string;
  brandName?: string;
}

interface ClientsBrands {
  clientCode: string;
  clientName?: string;
  brands: Brand[];
}

export enum ParcelDetailStatus {
  PREPARED = "Preparata",
  IN_TRIP_TO_TP = "In viaggio verso TP",
  IN_TRIP = "In viaggio verso dealer",
  CLOSED = "Chiuso",
  SUSPENDED = "Sospeso",
}

@Component({
  selector: "app-overview",
  standalone: true,
  templateUrl: "./overview.component.html",
  styleUrls: ["./overview.component.css"],
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    NgxPaginationModule,
    NgMultiSelectDropDownModule,
    ColumnCustomizeComponent,
    OrderByPipe,
    MatTooltipModule,
    ParcelMapComponent,
  ],
})
export class OverviewComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @ViewChild("signatureCanvas") signatureCanvas?: ElementRef<HTMLCanvasElement>;

  private countdownInterval: any = null;

  private signaturePad!: SignaturePad;

  signaturePreview: string | null = null;
  signatureError: string | null = null;
  private signatureInitialized = false;
  isReplacingSignature = false;

  showHideTrackings = false;

  ParcelDetailStatus = ParcelDetailStatus;

  currentPage: number = 1;
  itemsPerPage: number = 25;

  // Pagina corrente restituita dal backend: parcels e filteredParcels sono lo stesso array
  parcels: ViewParcels[] = [];
  filteredParcels: ViewParcels[] = [];

  // Colli che corrispondono ai filtri, su tutte le pagine
  totalRecords: number = 0;

  // true quando l'ultima ricerca ha risposto: distingue "nessun collo trovato" da ricerca non fatta o fallita
  searchCompleted: boolean = false;

  // Solo per il caricamento dei colli (spinner del "Totale colli"): isLoading vale anche per salvataggi e rollback
  isLoadingParcels: boolean = false;

  // Filtri dell'ultimo "Applica Filtri": li usano cambio pagina, ordinamento, ricaricamenti ed export
  private appliedFilters: ParcelSearchFilters | null = null;
  private parcelsRequest: Subscription | null = null;
  private filterOptionsRequest: Subscription | null = null;

  // Colli che un'azione "per bolla" modificherà, dal backend; null finché non arriva la risposta
  numberParcelsOfWaybill: number | null = null;
  private waybillCountRequest: Subscription | null = null;

  exportingType: "standard" | "original" | null = null;

  get isExporting(): boolean {
    return this.exportingType !== null;
  }

  successDeliveryPropagation = false;
  errorDeliveryPropagation: string | null = null;

  errorDeliveryNull: boolean = false;

  searchDealerCode: string = "";
  searchDDTCodes: string = "";
  searchParcelCode: string = "";
  searchParcelWaybillCode: string = "";
  parcelDateStart: string = "";
  parcelDateEnd: string = "";

  showUndefinedParcels: boolean = false;
  showBigOrders: boolean = false;

  parcelEstimatedDeliveryDateStart: string = "";
  parcelEstimatedDeliveryDateEnd: string = "";

  scheduleType: string = "";
  scheduleIsNight: string = "";

  dateError: string = "";
  isLoading: boolean = false;


  hovered: ComParcel | null = null;

  showUpdateComParcelModal: boolean = false;

  isCoordinatesCorrectSelectedParcel: boolean = false;
  showButtonCreateCoordinates: boolean = false;

  notificationStatus: string = ""; // "not_notified" | "notified"
  deliveryStatus: string = ""; // "delivered" | "not_delivered"
  inRangeStatus: string = "";
  modifyStatus: string = ""; // modified | not_modified
  withProblemsStatus: string = "";
  onTimeStatus: string = "";
  justificationStatus: string = "";
  misroutingStatus: string = "";

  allCarriers: Carrier[] = [];
  showFilters: boolean = true;

  selectedParcel: ViewParcels | null = null;
  showModal: boolean = false;

  showModalDetailModifies: boolean = false;

  showNotification = false;
  notificationMessage = "";

  showRollbackModal = false;
  rollbackChoice: "parcel" | "waybill" | null = null;

  editChoice: "parcel" | "waybill" | null = null;

  editForm: any = {
    parcelDate: "",
    parcelDeliveryDate: "",
    parcelDescription: "",
    parcelWeight: 0,
    parcelVolume: 0,
    parcelLatitude: null as number | null,
    parcelLongitude: null as number | null,
  };

  parcelDetailStatusFilter: string = "";

  restrictedMinutes: number | null = null;

  parcelDetailStatusOptions = [
    { value: "", label: "Tutti gli stati" },
    { value: "PREPARED", label: ParcelDetailStatus.PREPARED },
    { value: "IN_TRIP_TO_TP", label: ParcelDetailStatus.IN_TRIP_TO_TP },
    { value: "IN_TRIP", label: ParcelDetailStatus.IN_TRIP },
    { value: "CLOSED", label: ParcelDetailStatus.CLOSED },
    { value: "SUSPENDED", label: ParcelDetailStatus.SUSPENDED },
  ];

  private originalEdit: {
    parcelDeliveryDate: string | null;
    parcelLatitude: number | null;
    parcelLongitude: number | null;
  } = {
    parcelDeliveryDate: null,
    parcelLatitude: null,
    parcelLongitude: null,
  };

  filteredJustifications: Justification[] = [];
  justifications: Justification[] = [];
  filteredWarehouses: Warehouse[] = [];
  filteredWarehousesFrom: Warehouse[] = [];
  warehouseCode: string = "";
  warehouseFromCode: string = "";

  filteredBrands: Brand[] = [];

  selectedDealers: { dealerCode: string; dealerLabel: string }[] = [];
  filteredDealers: {
    dealerCode: string;
    dealerName: string;
    dealerLabel: string;
    count: number | null;
  }[] = [];
  dropdownSettingsDealer: IDropdownSettings = {
    singleSelection: false,
    idField: "dealerCode",
    textField: "dealerLabel",
    selectAllText: "Seleziona tutti",
    unSelectAllText: "Deseleziona tutti",
    itemsShowLimit: 2,
    allowSearchFilter: true,
    searchPlaceholderText: "Cerca dealer (nome, città o codice)",
  };

  private readonly MIN_PARTIAL_CODE_LENGTH = 4;

  // Opzioni delle tendine con il numero di colli su tutti i risultati (POST /tracking/parcels/filter-options).
  // Prima della prima ricerca: liste anagrafiche complete, con count null (a video "–")
  selectedCarrierCode: string = "";
  filteredCarriers: {
    carrierCode: string;
    carrierName: string;
    count: number | null;
  }[] = [];

  selectedRegionCode: string = "";
  filteredRegions: {
    regionCode: string;
    regionName: string;
    count: number | null;
  }[] = [];

  selectedDeliveryType: string = "";
  filteredTours: {
    tourCode: string;
    tourName: string;
    count: number | null;
  }[] = [];

  filterOnlyWithCoordsAndNoDeliveryDate: string = "";

  allTours: TourRouting[] = [];
  // Anagrafiche di dealer e regioni: servono a ripristinare le tendine iniziali al Reset
  private allDealers: DealerAnagraphic[] = [];
  private allRegions: Region[] = [];

  sortState = { active: "", direction: "" };

  selectedBrands: Brand[] = [];
  filteredClients: Client[] = [];
  selectedClients: Client[] = [];
  clientsBrands: ClientsBrands[] = [];
  dealers: Dealer[] = [];

  dropdownSettingsBrand: IDropdownSettings = {};
  dropdownSettingsClient: IDropdownSettings = {};

  selectedDeliveryMethod: string = "";

  showJustificationModal: boolean = false;

  showNoteModal: boolean = false;
  showCarrierMailModal: boolean = false;

  editFormJustification: any = {
    parcelJustificationId: "",
    parcelJustificationComment: "",
  };

  selectedComParcel: ComParcel | null = null;

  showJustificationModalComParcel: boolean = false;

  editFormJustificationComParcel: any = {
    parcelComplementaryJustificationId: "",
    parcelComplementaryJustificationComment: "",
  };

  editFormUpdateComParcel: any = {
    parcelComplementaryCarrierCode: "",
  };

  editFormNote: any = {
    parcelNote: "",
  };

  isJustificationsDropdownOpen = false;
  justificationSearchTerm = "";

  isDealerUser: boolean = false;

  showImportExcelModal = false;
  selectedExcelFile!: File;
  importJustificationCodeGroups: JustificationCodeGroup[] = [];
  isLoadingJustificationCodes = false;

  columns: TableColumn[] = [
    {
      field: "parcelHasMisrouting",
      label: "",
      visible: true,
      order: 0,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "parcelWaybillStatus",
      label: "Stato Bolla",
      visible: true,
      order: 1,
      specialOnly: true,
      sortable: true,
    },
    {
      field: "parcelDetailStatus",
      label: "Stato",
      visible: true,
      order: 2,
      sortable: true,
    },
    {
      field: "clientName",
      label: "Cliente",
      visible: true,
      order: 3,
      sortable: true,
    },
    {
      field: "brandName",
      label: "Marchio",
      visible: true,
      order: 4,
      sortable: true,
    },
    {
      field: "parcelCode",
      label: "Codice Collo",
      visible: true,
      order: 5,
      sortable: true,
    },
    {
      field: "parcelWaybillCode",
      label: "Codice Nuova Bolla",
      visible: true,
      order: 6,
      sortable: true,
      specialOrWithGeofencingTourBigOrderOnly: true,
    },
    {
      field: "parcelOriginalWaybillCode",
      label: "Codice Bolla",
      visible: true,
      order: 7,
      sortable: true,
    },
    {
      field: "waybillExternalWaybillCode",
      label: "Codice Bolla Esterna",
      visible: true,
      order: 8,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "waybillDdtAttachments",
      label: "Codici DDT",
      visible: true,
      order: 9,
      sortable: true,
      withGeofencingTourBigOrderOnly: true,
    },
    // { field: "parcelWaybillCodeFull", label: "Codice Spedizione", visible: true, order: 7, sortable: true },
    {
      field: "parcelDate",
      label: "Data Affido",
      visible: true,
      order: 10,
      sortable: true,
    },
    {
      field: "parcelWaybillOriginLocation",
      label: "Magazzino partenza",
      visible: true,
      order: 11,
      sortable: true,
    },
    {
      field: "parcelWaybillLastMileOrigin",
      label: "Magazzino ultimo miglio",
      visible: true,
      order: 12,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "parcelWaybillCarrierName",
      label: "Vettore",
      visible: true,
      order: 13,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "waybillCarriersSentEmails",
      label: "Mail Vettori",
      visible: true,
      order: 13.5,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "parcelCurrentWarehouse",
      label: "Magazzino corrente",
      visible: true,
      order: 14,
      specialOnly: true,
      sortable: true,
    },
    {
      field: "parcelDealerCode",
      label: "Codice Destinatario",
      visible: true,
      order: 15,
      sortable: true,
    },
    {
      field: "dealerName",
      label: "Destinatario",
      visible: true,
      order: 20,
      sortable: true,
    },
    {
      field: "dealerOperatingAddressStreet",
      label: "Indirizzo destinatario",
      visible: true,
      order: 23,
      sortable: true,
    },
    {
      field: "dealerOperatingAddressCity",
      label: "Città destinatario",
      visible: true,
      order: 24,
    },
    {
      field: "parcelRegionName",
      label: "Regione",
      visible: true,
      order: 25,
      sortable: true,
    },
    {
      field: "waybillAddressAlias",
      label: "Alias dealer",
      visible: true,
      order: 26,
      specialOnly: true,
    },
    {
      field: "parcelDeliveryDate",
      label: "Data Consegna",
      visible: true,
      order: 28,
      sortable: true,
    },
    {
      field: "parcelEstimatedDeliveryDate",
      label: "Stima Consegna",
      visible: true,
      order: 29,
      sortable: true,
      notDealer: true,
    },
    // { field: "parcelDeliveryChangeCutoffDate", label: "Cutoff Modifica", visible: true, order: 30, specialOnly: true, updatableOnly: true, sortable: true },
    // { field: "parcelDeliveryChangeCutoffCountdown", label: "Tempo residuo cutoff", visible: true, order: 31, specialOnly: true, updatableOnly: true, sortable: false },
    {
      field: "parcelOnTime",
      label: "In Orario",
      visible: true,
      order: 32,
      specialOnly: true,
      sortable: true,
    },
    {
      field: "parcelJustificationId",
      label: "Giustifica",
      visible: true,
      order: 34,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "minutesDelay",
      label: "Ritardo (min)",
      visible: true,
      order: 36,
      sortable: true,
      notDealer: true,
    },
    {
      field: "parcelWaybillDeliveryMethod",
      label: "Tipologia Consegna",
      visible: true,
      order: 37,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "parcelWaybillDeliveryType",
      label: "Tour interno",
      visible: true,
      order: 38,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "tourRoutingExternal",
      label: "Tour",
      visible: true,
      order: 39,
      sortable: true,
      withGeofencingTourBigOrderOnly: true,
    },
    {
      field: "parcelWaybillLoadingBay",
      label: "Baia",
      visible: true,
      order: 40,
      specialOnly: true,
      sortable: true,
    },
    {
      field: "parcelDeliveryStatus",
      label: "Stato Consegna",
      visible: true,
      order: 41,
      specialOnly: true,
      sortable: true,
    },
    {
      field: "parcelDeliveryReason",
      label: "Causale di consegna",
      visible: true,
      order: 42,
      sortable: true,
      notDealer: true,
    },
    {
      field: "parcelLatitude",
      label: "Lat",
      visible: true,
      order: 43,
      withGeofencingTourBigOrderOnly: true,
    },
    {
      field: "parcelLongitude",
      label: "Lng",
      visible: true,
      order: 44,
      withGeofencingTourBigOrderOnly: true,
    },
    {
      field: "distanceInMeters",
      label: "Distanza (m)",
      visible: true,
      order: 45,
      sortable: true,
      withGeofencingTourBigOrderOnly: true,
    },
    {
      field: "parcelWeight",
      label: "Peso",
      visible: true,
      order: 46,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "parcelVolume",
      label: "Volume",
      visible: true,
      order: 47,
      updatableOnly: true,
      sortable: true,
    },
    {
      field: "parcelModifyManual",
      label: "Data Modifica",
      visible: true,
      order: 48,
      specialOnly: true,
      sortable: true,
    },
    { field: "pod", label: "POD", visible: true, order: 49, notDealer: true },
    {
      field: "parcelNote",
      label: "Note",
      visible: true,
      updatableOnly: true,
      order: 52,
      sortable: true,
    },
    {
      field: "actions",
      label: "Azioni",
      visible: true,
      order: 55,
      specialOnly: true,
    },
  ];

  constructor(
    public http: HttpClient,
    functionService: FunctionService,
    router: Router,
    private notificationService: NotificationService,
    private errorHelperService: ErrorHelperService,
    private route: ActivatedRoute,
    private shipmentManagementService: ShipmentManagementService,
    private overviewParcelsService: OverviewParcelsService,
  ) {
    super(functionService, router); // Passa i servizi al costruttore padre
  }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const qpDeliveryStatus = params.get("deliveryStatus");
    const qpOnTimeStatus = params.get("onTimeStatus");
    const qpRegionCode = params.get("regionCode");
    const qpParcelDateStart = params.get("parcelDateStart");
    const qpParcelDateEnd = params.get("parcelDateEnd");
    const qpParcelEstimetedDateStart = params.get("parcelEstimetedDateStart");
    const qpParcelEstimetedDateEnd = params.get("parcelEstimetedDateEnd");
    const qpParcelWithProblemsStatus = params.get("withProblemsStatus");
    const qpInRangeStatus = params.get("inRangeStatus");
    // Parametri ripetuti nell'URL (uno per cliente/brand): getAll li legge tutti
    const qpClientCodes = params.getAll("parcelClientCodes");
    const qpBrandCodes = params.getAll("parcelBrandCodes");

    if (qpDeliveryStatus) {
      this.deliveryStatus = qpDeliveryStatus;
    }

    if (qpOnTimeStatus) {
      this.onTimeStatus = qpOnTimeStatus;
    }

    if (qpParcelWithProblemsStatus) {
      this.withProblemsStatus = qpParcelWithProblemsStatus;
    }

    if (qpRegionCode) {
      this.selectedRegionCode = qpRegionCode;
    }

    if (qpParcelDateStart) {
      this.parcelDateStart = qpParcelDateStart;
    }

    if (qpParcelDateEnd) {
      this.parcelDateEnd = qpParcelDateEnd;
    }

    if (qpParcelEstimetedDateStart) {
      this.parcelEstimatedDeliveryDateStart = qpParcelEstimetedDateStart;
    }

    if (qpParcelEstimetedDateEnd) {
      this.parcelEstimatedDeliveryDateEnd = qpParcelEstimetedDateEnd;
    }

    if (qpInRangeStatus) {
      this.inRangeStatus = qpInRangeStatus;
    }

    const saved = localStorage.getItem("parcelTableConfig");
    if (saved) {
      this.columns = JSON.parse(saved);
    }

    const savedPage = localStorage.getItem("currentParcelPage");
    this.currentPage = savedPage ? +savedPage : 1;

    // Recupera anche itemsPerPage dal localStorage
    const savedItemsPerPage = localStorage.getItem("itemsPerPage");
    this.itemsPerPage = savedItemsPerPage ? +savedItemsPerPage : 25;

    this.parcels = [];
    this.filteredParcels = [];

    //this.calcolaDataDefaultFiltri();

    const stored = localStorage.getItem("userFunctions");
    if (stored) {
      const parsed = JSON.parse(stored);
      this.clientsBrands = parsed.clients;
      this.dealers = parsed.dealers ?? null;
      this.isDealerUser = parsed.dealers != null;

      this.columns = this.columns.filter((col) => this.isColumnAllowed(col));

      this.columns.sort((a, b) => a.order - b.order);

      if (
        this.clientsBrands.length === 1 &&
        this.clientsBrands[0].clientCode === "CLT00001"
      ) {
        this.showBigOrders = true;
      }

      this.filteredClients = this.clientsBrands
        .map((cb) => ({
          clientCode: cb.clientCode,
          clientName: cb.clientName,
        }))
        .sort((a, b) => {
          if (!a.clientName && !b.clientName) return 0;
          if (!a.clientName) return 1;
          if (!b.clientName) return -1;
          return a.clientName.localeCompare(b.clientName);
        });

      const allBrands: Brand[] = this.clientsBrands
        .flatMap((cb) =>
          cb.brands.map((b) => ({
            brandCode: b.brandCode,
            brandName: b.brandName,
          })),
        )
        .sort((a, b) => {
          if (!a.brandName && !b.brandName) return 0;
          if (!a.brandName) return 1;
          if (!b.brandName) return -1;
          return a.brandName.localeCompare(b.brandName);
        });

      this.filteredBrands = Array.from(
        new Map(allBrands.map((b) => [b.brandCode, b])).values(),
      );

      this.dropdownSettingsBrand = {
        singleSelection: false,
        idField: "brandCode",
        textField: "brandName",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };
      this.dropdownSettingsClient = {
        singleSelection: false,
        idField: "clientCode",
        textField: "clientName",
        selectAllText: "Seleziona tutti",
        unSelectAllText: "Deseleziona tutti",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: "Cerca",
      };

      if (qpClientCodes.length > 0) {
        this.selectedClients = this.filteredClients.filter((c) =>
          qpClientCodes.includes(c.clientCode),
        );
      }

      if (qpBrandCodes.length > 0) {
        this.selectedBrands = this.filteredBrands.filter((c) =>
          qpBrandCodes.includes(c.brandCode),
        );
      }

      forkJoin({
        warehouses: this.http.get<Warehouse[]>(
          `${environment.apiUrl}/tracking/warehouses`,
        ),
        justifications: this.http.get<Justification[]>(
          `${environment.apiUrl}/tracking/justifications`,
        ),
        carriers: this.http.get<Carrier[]>(
          `${environment.apiUrl}/tracking/carriers`,
        ),
        // Servono solo per le tendine prima della prima ricerca: un errore non blocca la pagina
        tours: this.http
          .get<TourRouting[]>(`${environment.apiUrl}/tracking/tour-routings`)
          .pipe(catchError(() => of([] as TourRouting[]))),
        dealers: this.http
          .post<DealerAnagraphic[]>(
            `${environment.apiUrl}/tracking/dealers/options`,
            this.clientsBrands,
          )
          .pipe(catchError(() => of([] as DealerAnagraphic[]))),
        regions: this.http
          .get<Region[]>(`${environment.apiUrl}/tracking/regions`)
          .pipe(catchError(() => of([] as Region[]))),
      }).subscribe({
        next: (results) => {
          this.justifications = results.justifications;
          this.filteredWarehouses = results.warehouses;
          this.filteredWarehousesFrom = results.warehouses.filter((w) =>
            w.warehouseType?.split(";").includes("CDR"),
          );
          this.allCarriers = results.carriers;
          this.allTours = results.tours;
          this.allDealers = results.dealers;
          this.allRegions = results.regions;
          this.applyAnagraphicFilterOptions();
          // this.selectAllBrands();
          // this.selectAllClients();

          // Ricerca automatica solo se si arriva con i filtri nell'URL (es. link da Statistiche KPI colli)
          if (params.keys.length > 0) {
            this.applyFilters();
          }

          //this.loadData();
        },
        error: (err) => {
          console.error("Errore nel caricamento iniziale:", err);
        },
      });
    }

    this.startCutoffCountdownTimer();
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    this.parcelsRequest?.unsubscribe();
    this.filterOptionsRequest?.unsubscribe();
    this.waybillCountRequest?.unsubscribe();
  }

  private startCutoffCountdownTimer(): void {
    this.updateCutoffCountdowns();

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    this.countdownInterval = setInterval(() => {
      this.updateCutoffCountdowns();
    }, 1000);
  }

  private updateCutoffCountdowns(): void {
    const now = new Date().getTime();

    // Aggiorna i colli della pagina sul posto: parcels e filteredParcels sono lo stesso array
    for (const parcel of this.parcels) {
      const cutoff = parcel.parcelDeliveryChangeCutoffDate
        ? new Date(parcel.parcelDeliveryChangeCutoffDate).getTime()
        : null;

      if (!cutoff || isNaN(cutoff)) {
        parcel.parcelDeliveryChangeCutoffCountdown = "";
        parcel.parcelDeliveryChangeCutoffExpired = false;
        parcel.parcelDeliveryChangeCutoffWarning = false;
        continue;
      }

      const diffMs = cutoff - now;

      if (diffMs <= 0) {
        parcel.parcelDeliveryChangeCutoffCountdown = "00:00:00";
        parcel.parcelDeliveryChangeCutoffExpired = true;
        parcel.parcelDeliveryChangeCutoffWarning = true;
        continue;
      }

      parcel.parcelDeliveryChangeCutoffCountdown = this.formatCountdown(diffMs);
      parcel.parcelDeliveryChangeCutoffExpired = false;
      parcel.parcelDeliveryChangeCutoffWarning = diffMs <= 5 * 60 * 1000;
    }
  }

  shouldHideBigOrdersToggle(): boolean {
    return (
      !!this.clientsBrands &&
      this.clientsBrands.length === 1 &&
      this.clientsBrands[0]?.clientCode === "CLT00001"
    );
  }

  private isColumnAllowed(col: any): boolean {
    if (col.specialOnly && !this.canSpecial()) {
      return false;
    } else if (col.updatableOnly && !this.canSpecial() && !this.canUpdate()) {
      return false;
    } else if (
      col.withGeofencingTourBigOrderOnly &&
      !this.canWithGeofencingTourBigOrder()
    ) {
      return false;
    } else if (
      col.specialOrWithGeofencingTourBigOrderOnly &&
      !this.canSpecial() &&
      this.canWithGeofencingTourBigOrder() &&
      !this.canUpdate()
    ) {
      return false;
    } else if (
      col.notDealer &&
      !this.canSpecial() &&
      !this.canUpdate() &&
      this.isDealerUser
    ) {
      return false;
    }
    return true;
  }

  onClientsChange(): void {
    this.getIntersectionClientsBrands();
  }

  getIntersectionClientsBrands(): void {
    if (!this.selectedClients || this.selectedClients.length === 0) {
      // Nessun client selezionato → mostro tutti i brands
      this.filteredBrands = Array.from(
        new Map(
          this.clientsBrands
            .flatMap((cb) => cb.brands)
            .map((b) => [b.brandCode, b]),
        ).values(),
      );
      this.selectedBrands = []; // reset
      return;
    }

    // prendo i codici dei client selezionati
    const selectedCodes = this.selectedClients.map((c) => c.clientCode);

    // ottengo i brands per ogni client selezionato
    const brandLists = selectedCodes.map((code) => {
      const client = this.clientsBrands.find((cb) => cb.clientCode === code);
      return client ? client.brands : [];
    });

    // calcolo l’intersezione tra tutte le liste
    const intersection = brandLists.reduce((acc, curr) => {
      return acc.filter((b) => curr.some((x) => x.brandCode === b.brandCode));
    });

    // aggiorno i brands disponibili
    this.filteredBrands = intersection;
    this.selectedBrands = []; // reset per evitare selezioni incoerenti
  }

  selectAllClients() {
    this.selectedClients = [...this.filteredClients];

    this.getIntersectionClientsBrands();
  }

  deselectAllClients() {
    this.selectedClients = [];

    this.getIntersectionClientsBrands();
  }

  selectAllBrands() {
    this.selectedBrands = [...this.filteredBrands];
  }

  deselectAllBrands() {
    this.selectedBrands = [];
  }

  loadWarehouses(): void {
    this.http
      .get<Warehouse[]>(`${environment.apiUrl}/tracking/warehouses`)
      .subscribe({
        next: (data) => {
          this.filteredWarehouses = data;
          this.filteredWarehousesFrom = data.filter(
            (w) => w.warehouseType === "CDR",
          );
        },
        error: () => console.error("Errore nel caricamento dei warehouse"),
      });
  }

  loadBrands(): void {
    this.http
      .get<Brand[]>(`${environment.apiUrl}/shipment-request/brands`)
      .subscribe({
        next: (data) => (this.filteredBrands = data),
        error: () => console.error("Errore nel caricamento dei brands"),
      });
  }

  onItemsPerPageChange(): void {
    this.currentPage = 1; // Reset alla prima pagina quando cambi il numero di elementi
    localStorage.setItem("itemsPerPage", this.itemsPerPage.toString());
    this.loadData();
  }

  resetItemsPerPage(): void {
    this.itemsPerPage = 25;
    this.currentPage = 1;
    localStorage.setItem("itemsPerPage", "25");
    this.loadData();
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    localStorage.setItem("currentParcelPage", page.toString());
    this.loadData();
  }

  applyFilters(): void {
    this.currentPage = 1;
    // Niente risultati né paginazione della ricerca precedente se la validazione fallisce
    this.clearResults();

    this.dateError = "";

    this.searchParcelCode = this.normalizeCode(this.searchParcelCode);
    this.searchParcelWaybillCode = this.normalizeCode(
      this.searchParcelWaybillCode,
    );
    this.searchDDTCodes = this.normalizeCode(this.searchDDTCodes);
    this.searchDealerCode = this.normalizeCode(this.searchDealerCode);

    const hasParcelCode = !!this.searchParcelCode;
    const hasWaybillCode = !!this.searchParcelWaybillCode;
    const hasDDTCode = !!this.searchDDTCodes;

    const hasStartDate = !!this.parcelDateStart;
    const hasEndDate = !!this.parcelDateEnd;

    const hasEstimatedStartDate = !!this.parcelEstimatedDeliveryDateStart;
    const hasEstimatedEndDate = !!this.parcelEstimatedDeliveryDateEnd;

    // Verifica che ci sia almeno un criterio valido
    const hasValidDateRange =
      (hasStartDate && hasEndDate) ||
      (hasEstimatedStartDate && hasEstimatedEndDate);
    const hasAnyCode = hasParcelCode || hasWaybillCode || hasDDTCode;

    if (!hasAnyCode && !hasValidDateRange) {
      this.dateError =
        "Inserisci almeno un Codice Collo, un Codice Bolla, un Codice DDT o un intervallo di date (Affido o Consegna Stimata).";
      this.parcels = [];
      return;
    }

    if (!hasValidDateRange) {
      const tooShort = [
        this.searchParcelCode,
        this.searchParcelWaybillCode,
        this.searchDDTCodes,
      ]
        .filter((c) => !!c)
        .every((c) => c.length < this.MIN_PARTIAL_CODE_LENGTH);
      if (tooShort) {
        this.dateError = `Senza un intervallo di date inserisci almeno ${this.MIN_PARTIAL_CODE_LENGTH} caratteri del Codice Collo, Codice Bolla o Codice DDT.`;
        this.parcels = [];
        return;
      }
    }

    // Controllo correttezza intervallo date Affido
    if ((hasStartDate && !hasEndDate) || (!hasStartDate && hasEndDate)) {
      this.dateError =
        "Per filtrare per data di affido devi inserire entrambe le date o rimuoverle entrambe.";
      this.parcels = [];
      return;
    }

    if (hasStartDate && hasEndDate) {
      const start = new Date(this.parcelDateStart);
      const end = new Date(this.parcelDateEnd);

      if (start > end) {
        this.dateError =
          "La data di inizio affido non può essere successiva alla data di fine.";
        this.parcels = [];
        return;
      }
    }

    // Controllo correttezza intervallo date Consegna Stimata
    if (
      (hasEstimatedStartDate && !hasEstimatedEndDate) ||
      (!hasEstimatedStartDate && hasEstimatedEndDate)
    ) {
      this.dateError =
        "Per filtrare per data di consegna stimata devi inserire entrambe le date o rimuoverle entrambe.";
      this.parcels = [];
      return;
    }

    if (hasEstimatedStartDate && hasEstimatedEndDate) {
      const start = new Date(this.parcelEstimatedDeliveryDateStart);
      const end = new Date(this.parcelEstimatedDeliveryDateEnd);

      if (start > end) {
        this.dateError =
          "La data di inizio consegna stimata non può essere successiva alla data di fine.";
        this.parcels = [];
        return;
      }
    }

    // // Se non c'è né codice collo né codice bolla
    // if (!hasParcelCode && !hasWaybillCode) {
    //   if (!hasStartDate || !hasEndDate) {
    //     this.dateError = 'Inserisci un Codice Collo o un Codice Bolla oppure entrambe le date Inizio Affido e Fine Affido.';
    //     this.parcels = [];
    //     return;
    //   }
    // }

    // // Se è presente almeno una data
    // if (hasStartDate || hasEndDate) {
    //   if (!hasStartDate || !hasEndDate) {
    //     this.dateError = 'Per filtrare per data devi inserire sia la data di inizio che quella di fine.';
    //     this.parcels = [];
    //     return;
    //   }

    //   const start = new Date(this.parcelDateStart);
    //   const end = new Date(this.parcelDateEnd);

    //   if (start > end) {
    //     this.dateError = 'La data di inizio non può essere successiva alla data di fine.';
    //     this.parcels = [];
    //     return;
    //   }
    // }

    // if(!this.searchParcelCode && !this.searchParcelWaybillCode) {
    //   if (!this.parcelDateStart || !this.parcelDateEnd) {
    //     this.dateError = 'Seleziona o un Codice Collo o un Codice Bolla oppure le date Inizio Affido e Fine Affido per applicare il filtro.';
    //     return;
    //   }

    //   const start = new Date(this.parcelDateStart);
    //   const end = new Date(this.parcelDateEnd);

    //   if (start > end) {
    //     this.dateError = 'La data di inizio non può essere successiva alla data di fine.';
    //     return;
    //   }
    // }

    //this.loadBrands();
    this.loadWarehouses();
    this.appliedFilters = this.buildSearchFilters();
    this.loadData();
    this.loadFilterOptions();
  }

  private clearResults(): void {
    // Una ricerca annullata non arriva mai a next/error: il loader va spento qui
    if (this.parcelsRequest && !this.parcelsRequest.closed) {
      this.parcelsRequest.unsubscribe();
      this.isLoading = false;
      this.isLoadingParcels = false;
    }
    this.appliedFilters = null;
    this.parcels = [];
    this.filteredParcels = [];
    this.totalRecords = 0;
    this.searchCompleted = false;
  }

  // Filtri inviati al backend: tutti i filtri della pagina, applicati lato server
  private buildSearchFilters(): ParcelSearchFilters {
    let clientsBrandsSelected: ClientsBrands[];
    if (this.filteredClients.length == 1) {
      this.selectedClients = [...this.filteredClients];
    }
    if (this.selectedClients.length > 0) {
      clientsBrandsSelected = this.selectedClients.map((sc) => {
        // trovo il client originale da clientsBrands
        const originalClient = this.clientsBrands.find(
          (cb) => cb.clientCode === sc.clientCode,
        );

        var filteredBrandsFromClient: Brand[] = [];
        if (this.selectedBrands.length > 0) {
          // brands effettivi = intersezione tra quelli del client e quelli selezionati
          filteredBrandsFromClient = (originalClient?.brands || []).filter(
            (b) =>
              this.selectedBrands.some((sb) => sb.brandCode === b.brandCode),
          );
        } else {
          filteredBrandsFromClient = this.filteredBrands;
        }

        return {
          clientCode: sc.clientCode,
          clientName: sc.clientName,
          brands: filteredBrandsFromClient,
        } as ClientsBrands;
      });
    } else if (this.selectedBrands && this.selectedBrands.length > 0) {
      // nessun client selezionato, ma brand sì
      clientsBrandsSelected = this.clientsBrands
        .map((cb) => {
          const matchingBrands = cb.brands.filter((b) =>
            this.selectedBrands.some((sb) => sb.brandCode === b.brandCode),
          );
          if (matchingBrands.length > 0) {
            return {
              clientCode: cb.clientCode,
              clientName: cb.clientName,
              brands: matchingBrands,
            } as ClientsBrands;
          }
          return null;
        })
        .filter((cb) => cb !== null) as ClientsBrands[];
    } else {
      // né client né brand selezionati → ritorno tutto
      clientsBrandsSelected = this.clientsBrands;
    }

    //   let params = new HttpParams()
    //     .set('clients', clientsBrandsSelected && clientsBrandsSelected.length > 0
    //       ? JSON.stringify(clientsBrandsSelected)
    //       : '')
    //     .set('parcelWaybillCode', this.searchParcelWaybillCode || '')
    //     .set('parcelCode', this.searchParcelCode || '')
    //     .set('parcelDateStart', this.parcelDateStart)
    //     .set('parcelDateEnd', this.parcelDateEnd)
    //     .set('parcelDealerCode', this.searchDealerCode != '' ? this.searchDealerCode : this.selectedDealerCode)
    //     .set('warehouseCode', this.warehouseCode || '')
    //     .set('regionCode', this.selectedRegionCode)
    //     .set('carrierCode', this.selectedCarrierCode)
    //     .set('deliveryType', this.selectedDeliveryType);

    //     // CAMBIA TUTTO IN POST
    //   this.http.post<ViewParcels[]>(`${environment.apiUrl}/tracking/parcels`, { params }).subscribe({
    //     next: (data) => {
    //       this.parcels = data.map(p => ({ ...p, showTrackings: false }));
    //       this.applyFrontendFilters();
    //       this.updateDealerFilterOptions(this.filteredParcels);
    //       this.updateCarrierFilterOptions(this.filteredParcels);
    //       this.updateRegionFilterOptions(this.filteredParcels);
    //       this.updateTourFilterOptions(this.filteredParcels);
    //       this.isLoading = false; // nascondi il loader
    //     },
    //     error: (err) => {
    //       console.error('Errore durante la chiamata HTTP:', err);
    //       this.isLoading = false; // nascondi il loader anche in caso di errore
    //     }
    //   });
    return {
      clients: clientsBrandsSelected || [],
      parcelWaybillCode: this.searchParcelWaybillCode || "",
      parcelCode: this.searchParcelCode || "",
      parcelDateStart: this.parcelDateStart,
      parcelDateEnd: this.parcelDateEnd,
      parcelDealerCode: this.searchDealerCode || "",
      warehouseCode: this.warehouseCode || "",
      warehouseFromCode: this.warehouseFromCode || "",
      regionCode: this.selectedRegionCode,
      carrierCode: this.selectedCarrierCode,
      deliveryType: this.selectedDeliveryType,
      nightDay: this.scheduleIsNight,
      parcelEstimatedDeliveryDateStart: this.parcelEstimatedDeliveryDateStart,
      parcelEstimatedDeliveryDateEnd: this.parcelEstimatedDeliveryDateEnd,
      waybillDDT: this.searchDDTCodes,
      inRangeStatus: this.inRangeStatus,
      notificationStatus: this.notificationStatus,
      deliveryStatus: this.deliveryStatus,
      modifyStatus: this.modifyStatus,
      onTimeStatus: this.onTimeStatus,
      scheduleType: this.scheduleType,
      deliveryMethod: this.selectedDeliveryMethod,
      justificationStatus: this.justificationStatus,
      withProblemsStatus: this.withProblemsStatus,
      detailStatuses: this.parcelDetailStatusFilter
        ? [this.parcelDetailStatusFilter]
        : [],
      misroutingStatus: this.misroutingStatus,
      showUndefinedParcels: this.showUndefinedParcels,
      showBigOrders: this.showBigOrders,
      onlyWithCoordsAndNoDeliveryDate:
        this.filterOnlyWithCoordsAndNoDeliveryDate === "with_coords_no_delivery"
          ? true
          : null,
      parcelDealerCodes: (this.selectedDealers || []).map((d) => d.dealerCode),
    };
  }

  // Dopo un'azione su un collo: stessa pagina, e conteggi delle tendine aggiornati
  private refreshParcels(): void {
    this.loadData();
    this.loadFilterOptions();
  }

  // Carica la pagina corrente con i filtri dell'ultimo "Applica Filtri" e l'ordinamento attivo
  loadData(): void {
    if (!this.appliedFilters) {
      return;
    }

    this.parcelsRequest?.unsubscribe();
    this.isLoading = true; // mostra il loader
    this.isLoadingParcels = true;

    const filters: ParcelSearchFilters = {
      ...this.appliedFilters,
      page: this.currentPage,
      pageSize: this.itemsPerPage,
      sortBy: this.sortState.active,
      sortDirection: this.sortState.direction,
    };

    this.parcelsRequest = this.overviewParcelsService
      .searchParcels<ViewParcels>(filters)
      .subscribe({
        next: (response) => {
          // Pagina oltre l'ultima (es. dopo un'azione che ha tolto colli dai risultati): si va all'ultima
          if (
            response.parcels.length === 0 &&
            response.totalCount > 0 &&
            this.currentPage > 1
          ) {
            this.currentPage = Math.max(1, response.totalPages);
            this.loadData();
            return;
          }

          this.totalRecords = response.totalCount;
          this.searchCompleted = true;
          this.parcels = response.parcels.map((p) => {
            const isOrphan =
              !!p.parcelCode &&
              (!p.parcelWaybillCode || p.parcelWaybillCode.trim() === "");

            const isBigOrder = p.parcelWaybillDeliveryMethod === "BIG_ORDER";

            const parcelWaybillStatus = isOrphan
              ? "UNDEFINED"
              : p.parcelWaybillStatus;

            return {
              ...p,
              isOrphan,
              isBigOrder,
              parcelWaybillStatus: parcelWaybillStatus,
              showTrackings: false,
              showComParcels: false,
              activeTab: "tracking" as "tracking" | "map",
              minutesDelay: isOrphan
                ? null
                : this.getMinutesDelayNumber(
                    p.parcelOnTime,
                    p.parcelDeliveryDate,
                    p.parcelEstimatedDeliveryDate,
                  ),
            };
          });

          this.filteredParcels = this.parcels;
          this.updateCutoffCountdowns();
          this.isLoading = false;
          this.isLoadingParcels = false;
        },
        error: (err) => {
          console.error("Errore durante la chiamata HTTP:", err);
          this.isLoading = false; // nascondi il loader anche in caso di errore
          this.isLoadingParcels = false;
          this.searchCompleted = false;
          this.notificationService.error(
            this.errorHelperService.extractBackendMessage(err),
          );
        },
      });
  }

  toggleTrackings(parcel: ViewParcels) {
    parcel.showTrackings = !parcel.showTrackings;
    if (parcel.showTrackings) {
      parcel.trackings = parcel.trackings.sort((a, b) => {
        // Se entrambi null → pari
        if (!a.trackingCreatedAt && !b.trackingCreatedAt) return 0;
        // Se solo a è null → dopo
        if (!a.trackingCreatedAt) return 1;
        // Se solo b è null → dopo
        if (!b.trackingCreatedAt) return -1;
        // Entrambi valorizzati → confronto per data
        return (
          new Date(a.trackingCreatedAt).getTime() -
          new Date(b.trackingCreatedAt).getTime()
        );
      });

      // Animazione barre
      const lines = document.querySelectorAll(".line");
      lines.forEach((line: any) => {
        if (
          line.classList.contains("line-green") ||
          line.classList.contains("line-red") ||
          line.classList.contains("line-blue")
        ) {
          line.style.width = "0";
          setTimeout(() => {
            line.style.transition = "width 1s ease-in-out";
            line.style.width = "100%";
          }, 100);
        }
      });
    }
  }

  private normalizeCode(code: string | null | undefined): string {
    return (code ?? "").trim();
  }

  formatDateForInput(date: string | Date | null): string | null {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    const hours = ("0" + d.getHours()).slice(-2);
    const minutes = ("0" + d.getMinutes()).slice(-2);
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  // Opzioni delle tendine con il numero di colli su tutti i risultati dei filtri applicati.
  // Si ricaricano solo quando cambiano i filtri, non al cambio pagina o ordinamento
  private loadFilterOptions(): void {
    if (!this.appliedFilters) {
      return;
    }

    this.filterOptionsRequest?.unsubscribe();
    this.filterOptionsRequest = this.overviewParcelsService
      .getFilterOptions(this.appliedFilters)
      .subscribe({
        next: (options) => this.applyFilterOptions(options),
        error: (err) => {
          console.error(
            "Errore nel caricamento delle opzioni dei filtri:",
            err,
          );
          this.notificationService.error(
            this.errorHelperService.extractBackendMessage(err),
          );
        },
      });
  }

  private applyFilterOptions(options: ParcelFilterOptions): void {
    this.filteredDealers = options.dealers.map((d) => {
      const code = d.code || "UNDEFINED";
      const name =
        d.name || (code === "UNDEFINED" ? "UNDEFINED" : "Dealer sconosciuto");
      return {
        dealerCode: code,
        dealerName: name,
        dealerLabel: this.buildDealerLabel(
          code,
          name,
          d.city || "",
          d.parcelsCount,
        ),
        count: d.parcelsCount,
      };
    });

    const previousRegions = this.filteredRegions;

    // Vettori: UNDEFINED = colli senza vettore ("Carrier sconosciuto"), selezionabile come filtro.
    // Regioni e tour senza codice esclusi: selezionarli non filtrerebbe
    this.filteredCarriers = options.carriers
      .filter((c) => !!c.code)
      .map((c) => ({
        carrierCode: c.code as string,
        carrierName: this.carrierOptionName(c.code as string, c.name),
        count: c.parcelsCount,
      }));

    this.filteredRegions = options.regions
      .filter((r) => !!r.code && r.name != null)
      .map((r) => ({
        regionCode: r.code as string,
        regionName: r.name as string,
        count: r.parcelsCount,
      }));

    this.filteredTours = options.tours
      .filter((t) => !!t.code)
      .map((t) => ({
        tourCode: t.code as string,
        tourName: t.name || (t.code as string),
        count: t.parcelsCount,
      }));

    // Il valore selezionato resta sempre tra le opzioni, anche con zero colli: altrimenti la tendina
    // mostrerebbe "Tutti" mentre il filtro è ancora applicato
    const carrierCode = this.appliedFilters?.carrierCode;
    if (
      carrierCode &&
      !this.filteredCarriers.some((c) => c.carrierCode === carrierCode)
    ) {
      const carrierName = this.carrierOptionName(
        carrierCode,
        this.allCarriers.find((c) => c.carrierCode === carrierCode)
          ?.carrierName,
      );
      this.filteredCarriers.unshift({ carrierCode, carrierName, count: 0 });
    }
    const regionCode = this.appliedFilters?.regionCode;
    if (
      regionCode &&
      !this.filteredRegions.some((r) => r.regionCode === regionCode)
    ) {
      const regionName =
        previousRegions.find((r) => r.regionCode === regionCode)?.regionName ||
        regionCode;
      this.filteredRegions.unshift({ regionCode, regionName, count: 0 });
    }
    const tourCode = this.appliedFilters?.deliveryType;
    if (tourCode && !this.filteredTours.some((t) => t.tourCode === tourCode)) {
      this.filteredTours.unshift({ tourCode, tourName: tourCode, count: 0 });
    }

    // Come per vettore, regione e tour: i dealer selezionati restano tra le opzioni anche con zero colli.
    const byCode = new Map(this.filteredDealers.map((d) => [d.dealerCode, d]));
    for (const sd of [...(this.selectedDealers || [])].reverse()) {
      if (byCode.has(sd.dealerCode)) {
        continue;
      }
      const anagraphic = this.allDealers.find(
        (d) => d.dealerCode === sd.dealerCode,
      );
      const name =
        sd.dealerCode === "UNDEFINED"
          ? "UNDEFINED"
          : anagraphic?.dealerName || "Dealer sconosciuto";
      const option = {
        dealerCode: sd.dealerCode,
        dealerName: name,
        dealerLabel: this.buildDealerLabel(
          sd.dealerCode,
          name,
          anagraphic?.dealerOperatingAddressCity || "",
          0,
        ),
        count: 0,
      };
      this.filteredDealers.unshift(option);
      byCode.set(sd.dealerCode, option);
    }

    // Etichette della selezione aggiornate con i nuovi conteggi
    this.selectedDealers = (this.selectedDealers || []).map((sd) => ({
      dealerCode: sd.dealerCode,
      dealerLabel: byCode.get(sd.dealerCode)!.dealerLabel,
    }));
  }

  // Tendine prima della prima ricerca: tutte le voci delle anagrafiche, senza conteggio.
  // La prima risposta di filter-options le sostituisce con le sole voci presenti nei risultati
  private applyAnagraphicFilterOptions(): void {
    const dealers = this.allDealers;
    const regions = this.allRegions;
    const byName = (a: string, b: string) => a.localeCompare(b);

    // Utente dealer: solo i suoi dealer
    const ownDealerCodes = this.isDealerUser
      ? new Set((this.dealers || []).map((d) => d.dealerCode))
      : null;
    const dealerOptions = dealers
      .filter((d) => !!d.dealerCode)
      .filter((d) => !ownDealerCodes || ownDealerCodes.has(d.dealerCode!))
      .map((d) => {
        const code = d.dealerCode as string;
        const name = d.dealerName || "Dealer sconosciuto";
        return {
          dealerCode: code,
          dealerName: name,
          dealerLabel: this.buildDealerLabel(
            code,
            name,
            d.dealerOperatingAddressCity || "",
            null,
          ),
          count: null,
        };
      })
      .sort((a, b) => byName(a.dealerName, b.dealerName));
    // Colli orfani, come in filter-options
    if (this.canSpecial()) {
      dealerOptions.unshift({
        dealerCode: "UNDEFINED",
        dealerName: "UNDEFINED",
        dealerLabel: this.buildDealerLabel("UNDEFINED", "UNDEFINED", "", null),
        count: null,
      });
    }
    this.filteredDealers = dealerOptions;

    this.filteredCarriers = this.allCarriers
      .filter((c) => !!c.carrierCode)
      .map((c) => ({
        carrierCode: c.carrierCode,
        carrierName: this.carrierOptionName(c.carrierCode, c.carrierName),
        count: null,
      }))
      .sort((a, b) => byName(a.carrierName, b.carrierName));
    // Colli senza vettore: in fondo, come in filter-options (nome null ordinato per ultimo)
    this.filteredCarriers.push({
      carrierCode: "UNDEFINED",
      carrierName: this.carrierOptionName("UNDEFINED", null),
      count: null,
    });

    this.filteredRegions = regions
      .filter((r) => !!r.regionCode && r.regionName != null)
      .map((r) => ({
        regionCode: r.regionCode,
        regionName: r.regionName as string,
        count: null,
      }))
      .sort((a, b) => byName(a.regionName, b.regionName));

    const tourCodes = new Set(
      this.allTours.map((t) => t.tourRoutingCode).filter((code) => !!code),
    );
    this.filteredTours = Array.from(tourCodes)
      .sort(byName)
      .map((code) => ({ tourCode: code, tourName: code, count: null }));
  }

  private carrierOptionName(
    code: string,
    name: string | null | undefined,
  ): string {
    return code === "UNDEFINED" ? "Carrier sconosciuto" : name || code;
  }

  private buildDealerLabel(
    code: string,
    name: string,
    city: string,
    count: number | null,
  ): string {
    // UNDEFINED = colli orfani (senza bolla, quindi senza dealer): il codice resta quello inviato al backend
    if (code === "UNDEFINED") {
      return `Senza dealer (${count ?? "–"})`;
    }
    const cityPart = city ? ` - ${city}` : "";
    return `${name}${cityPart} [${code}] (${count ?? "–"})`;
  }

  exportParcelsToExcel(): void {
    this.exportParcels(false, "totale_colli");
  }

  exportParcelsOriginalToExcel(): void {
    this.exportParcels(true, "totale_colli_con_dati_originali");
  }

  // Export lato server di tutti i colli che corrispondono ai filtri applicati, non solo della pagina visualizzata
  private exportParcels(
    withOriginalData: boolean,
    fallbackBaseName: string,
  ): void {
    if (!this.appliedFilters || this.isExporting) {
      return;
    }

    this.exportingType = withOriginalData ? "original" : "standard";

    const filters: ParcelSearchFilters = {
      ...this.appliedFilters,
      sortBy: this.sortState.active,
      sortDirection: this.sortState.direction,
    };

    this.overviewParcelsService
      .exportParcelsExcel(filters, withOriginalData)
      .subscribe({
        next: ({ blob, fileName }) => {
          this.exportingType = null;

          const now = new Date();
          const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}${now.getHours().toString().padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now.getSeconds().toString().padStart(2, "0")}`;

          FileSaver.saveAs(
            blob,
            fileName ?? `${fallbackBaseName}_${timestamp}.xlsx`,
          );
        },
        error: (err) => {
          this.exportingType = null;
          console.error("Errore durante l'esportazione Excel:", err);
          this.notificationService.error(
            this.errorHelperService.extractBackendMessage(err),
          );
        },
      });
  }

  // Formatta date in formato dd/MM/yyyy HH:mm
  private formatDate(date: any): string {
    if (!date) return "";
    const d = new Date(date);
    const pad = (n: number) => n.toString().padStart(2, "0");
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  resetFilters(): void {
    this.scheduleType = "";
    this.selectedClients = [];
    this.selectedBrands = [];
    this.searchDealerCode = "";
    this.searchDDTCodes = "";
    this.selectedDealers = [];
    this.notificationStatus = "";
    this.justificationStatus = "";
    this.deliveryStatus = "";
    this.searchParcelCode = "";
    this.searchParcelWaybillCode = "";
    this.inRangeStatus = "";
    this.selectedCarrierCode = "";
    this.warehouseCode = "";
    this.warehouseFromCode = "";
    this.selectedRegionCode = "";
    this.onTimeStatus = "";
    this.modifyStatus = "";
    this.withProblemsStatus = "";
    this.selectedDeliveryType = "";
    this.scheduleIsNight = "";
    this.selectedDeliveryMethod = "";
    this.parcelDateStart = "";
    this.parcelDateEnd = "";
    this.parcelEstimatedDeliveryDateStart = "";
    this.parcelEstimatedDeliveryDateEnd = "";
    this.parcelDetailStatusFilter = "";
    this.misroutingStatus = "";
    this.showUndefinedParcels = false;
    this.showBigOrders = false;
    this.showHideTrackings = false;

    //this.calcolaDataDefaultFiltri();

    // Tendine di nuovo con tutte le voci delle anagrafiche, come appena entrati in pagina
    this.filterOptionsRequest?.unsubscribe();
    this.applyAnagraphicFilterOptions();

    // Applica di nuovo il filtro (se necessario)
    this.applyFilters();
  }

  calcolaDataDefaultFiltri(): void {
    // Calcolo data predefinita (ieri o venerdì)
    const today = new Date();
    let defaultDate = new Date(today);

    if (today.getDay() === 0) {
      // Domenica → venerdì
      defaultDate.setDate(today.getDate() - 2);
    } else if (today.getDay() === 1) {
      // Lunedì → venerdì
      defaultDate.setDate(today.getDate() - 3);
    } else {
      // Altri giorni → ieri
      defaultDate.setDate(today.getDate() - 1);
    }

    const formattedDate = defaultDate.toISOString().split("T")[0];
    this.parcelDateStart = formattedDate;
    this.parcelDateEnd = formattedDate;
  }

  viewDetailsModifiesManual(parcel: ViewParcels) {
    this.selectedParcel = parcel;
    this.showModalDetailModifies = true;
  }

  closeModalDetailModifies() {
    this.selectedParcel = null;
    this.showModalDetailModifies = false;
  }

  private shiftDate(dateStr: string, days: number): string {
    const date = new Date(dateStr);
    date.setDate(date.getDate() + days);
    return date.toISOString().substring(0, 10); // Format: yyyy-mm-dd
  }

  shiftCreationDates(days: number): void {
    if (this.parcelDateStart) {
      this.parcelDateStart = this.shiftDate(this.parcelDateStart, days);
    } else {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      this.parcelDateStart = this.shiftDate(formattedDate, days);
    }
    if (this.parcelDateEnd) {
      this.parcelDateEnd = this.shiftDate(this.parcelDateEnd, days);
    } else {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      this.parcelDateEnd = this.shiftDate(formattedDate, days);
    }
  }

  shiftEstimatedDates(days: number): void {
    if (this.parcelEstimatedDeliveryDateStart) {
      this.parcelEstimatedDeliveryDateStart = this.shiftDate(
        this.parcelEstimatedDeliveryDateStart,
        days,
      );
    } else {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      this.parcelEstimatedDeliveryDateStart = this.shiftDate(
        formattedDate,
        days,
      );
    }

    if (this.parcelEstimatedDeliveryDateEnd) {
      this.parcelEstimatedDeliveryDateEnd = this.shiftDate(
        this.parcelEstimatedDeliveryDateEnd,
        days,
      );
    } else {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      this.parcelEstimatedDeliveryDateEnd = this.shiftDate(formattedDate, days);
    }
  }

  // Ordinamento lato server: si riparte dalla prima pagina
  setSort(column: string): void {
    if (this.sortState.active === column) {
      // Toggle direction
      this.sortState.direction =
        this.sortState.direction === "asc" ? "desc" : "asc";
    } else {
      this.sortState.active = column;
      this.sortState.direction = "asc";
    }
    this.currentPage = 1;
    this.loadData();
  }

  getMinutesDelayNumber(
    parcelOnTime: string,
    parcelDeliveryDate: string,
    parcelEstimatedDeliveryDate: string,
  ): number {
    if (
      parcelOnTime === "ON_TIME" ||
      !parcelDeliveryDate ||
      !parcelEstimatedDeliveryDate
    ) {
      return 0;
    }

    const deliveryDate = new Date(parcelDeliveryDate);
    const estimatedDate = new Date(parcelEstimatedDeliveryDate);

    const diffMs = deliveryDate.getTime() - estimatedDate.getTime();
    return Math.max(Math.floor(diffMs / (1000 * 60)), 0);
  }

  getValue(p: any, field: string): any {
    return p[field];
  }

  undoParcel(parcel: any, allParcels: boolean) {
    this.isLoading = true;
    this.showRollbackModal = true;

    this.http
      .put(
        `${environment.apiUrl}/tracking/rollbackDelivery/${parcel.parcelCode}/${allParcels}`,
        null,
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.refreshParcels();
          this.closeRollbackModal();
          this.notificationService.success("Consegna annullata con successo!");
        },
        error: (err) => {
          this.isLoading = false;
          this.closeRollbackModal();
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        },
      });
  }

  closeRollbackModal() {
    this.showRollbackModal = false;
    this.selectedParcel = null;
    this.rollbackChoice = null;
  }

  openRollbackModal(parcel: any) {
    this.selectedParcel = parcel;
    this.showRollbackModal = true;
    this.rollbackChoice = null;
  }

  startRollback(scope: "parcel" | "waybill") {
    this.rollbackChoice = scope;
  }

  cancelRollback() {
    this.rollbackChoice = null;
  }

  confirmRollback() {
    if (!this.selectedParcel || !this.rollbackChoice) return;
    const allParcels = this.rollbackChoice === "waybill";
    this.undoParcel(this.selectedParcel, allParcels);
  }

  openJustificationModal(parcel: any) {
    if (parcel.parcelDeliveryDate != null && parcel.parcelOnTime == "ON_TIME") {
      return;
    }
    this.selectedParcel = parcel;
    this.loadWaybillParcelsCount(parcel, "justifiable");

    if (this.selectedParcel?.clientIsPersonalJustifications === "Y") {
      this.filteredJustifications = this.justifications.filter(
        (j) => j.justificationClientCode === parcel.parcelClientCode,
      );
    } else {
      this.filteredJustifications = this.justifications.filter(
        (j) => !j.justificationClientCode,
      );
    }

    this.editFormJustification = {
      parcelJustificationId: parcel.parcelJustificationId || "",
      parcelJustificationComment: parcel.parcelJustificationComment || "",
    };

    this.showJustificationModal = true;
  }

  openJustificationModalComParcel(comParcel: any) {
    this.selectedComParcel = comParcel;

    this.filteredJustifications = this.justifications.filter(
      (j) => !j.justificationClientCode,
    );
    this.editFormJustificationComParcel = {
      parcelComplementaryJustificationId:
        comParcel.parcelComplementaryJustificationId || "",
      parcelComplementaryJustificationComment:
        comParcel.parcelComplementaryJustificationComment || "",
    };

    this.showJustificationModalComParcel = true;
  }

  closeJustificationModal() {
    this.showJustificationModal = false;
    this.selectedParcel = null;
  }

  saveJustification(allParcels: boolean) {
    this.isLoading = true;

    const payload = {
      parcelCode: this.selectedParcel?.parcelCode,
      parcelJustificationId: this.editFormJustification.parcelJustificationId,
      parcelJustificationComment:
        this.editFormJustification.parcelJustificationComment,
      parcelClientCode: this.selectedParcel?.parcelClientCode,
      parcelBrandCode: this.selectedParcel?.parcelBrandCode,
    };

    this.http
      .put(
        `${environment.apiUrl}/tracking/parcel/justification/${allParcels}`,
        payload,
      )
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.refreshParcels();
          this.closeJustificationModal();
          this.notificationService.success(
            "Giustificazione aggiornata con successo!",
          );
        },
        error: (err) => {
          this.isLoading = false;
          this.closeJustificationModal();
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        },
      });
  }

  closeJustificationModalComParcel() {
    this.showJustificationModalComParcel = false;
    this.selectedComParcel = null;
  }

  saveJustificationComParcel(allComAfter: boolean) {
    this.isLoading = true;

    const payload = {
      parcelComplementaryId: this.selectedComParcel?.parcelComplementaryId,
      parcelComplementarySequence:
        this.selectedComParcel?.parcelComplementarySequence,
      parcelComplementaryCode: this.selectedComParcel?.parcelComplementaryCode,
      parcelComplementaryWaybillCode:
        this.selectedComParcel?.parcelComplementaryWaybillCode,
      parcelComplementaryJustificationId:
        this.editFormJustificationComParcel.parcelComplementaryJustificationId,
      parcelComplementaryJustificationComment:
        this.editFormJustificationComParcel
          .parcelComplementaryJustificationComment,
    };

    this.http
      .put(
        `${environment.apiUrl}/tracking/comParcel/justification/${allComAfter}`,
        payload,
      )
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.refreshParcels();
          this.closeJustificationModalComParcel();
          this.notificationService.success(
            "Giustificazione aggiornata con successo!",
          );
        },
        error: (err) => {
          this.isLoading = false;
          this.closeJustificationModalComParcel();
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        },
      });
  }

  coordinateRegex = /^-?[1-9]\d?([,.]\d+)?$/;

  coordinatesValid = true;

  checkCoordinates() {
    const latStr = this.editForm.parcelLatitude
      ?.toString()
      .replace(",", ".")
      .trim();
    const lonStr = this.editForm.parcelLongitude
      ?.toString()
      .replace(",", ".")
      .trim();

    const latEmpty = !latStr;
    const lonEmpty = !lonStr;

    const latOk = latEmpty || this.coordinateRegex.test(latStr);
    const lonOk = lonEmpty || this.coordinateRegex.test(lonStr);

    this.coordinatesValid = latOk && lonOk;

    if (latOk && !latEmpty) {
      this.editForm.parcelLatitude = parseFloat(latStr);
    }
    if (lonOk && !lonEmpty) {
      this.editForm.parcelLongitude = parseFloat(lonStr);
    }
  }

  getJustificationLabel(type: string): string {
    switch (type) {
      case "MISSING_DELIVERY":
        return "MANCATA CONSEGNA";
      case "DELAY":
        return "RITARDO";
      default:
        return type;
    }
  }

  getStepClass(t: ViewTrackings) {
    if (!t.rightedZone) return "done";
    if (t.rightedZone && !t.trackingCreatedAt) return "empty";
    if (t.rightedZone && t.trackingCreatedAt) return "error";
    return "";
  }

  getTextClass(t: ViewTrackings) {
    if (!t.rightedZone) return "green-text";
    if (t.rightedZone && !t.trackingCreatedAt) return "grey-text";
    if (t.rightedZone && t.trackingCreatedAt) return "red-text";
    return "";
  }

  getLineClass(t: ViewTrackings) {
    if (!t.rightedZone) return "line-green";
    if (t.rightedZone && t.trackingCreatedAt) return "line-red";
    return "line-grey";
  }

  getLineClassStart(p: ViewParcels) {
    if (p.parcelDate) return "line-green";
    return "line-grey";
  }

  isDepartureFromOrigin(p: ViewParcels) {
    let trackingsWarehouseOrigin = p.trackings.filter(
      (t) => t.warehouseNameTracking == p.parcelWaybillOriginLocation,
    );
    if (trackingsWarehouseOrigin.length > 0)
      return trackingsWarehouseOrigin[0].trackingCreatedAt;
    return null;
  }

  getIntermediateTrackings(p: ViewParcels) {
    let tpCode = this.filteredWarehouses.filter(
      (w) => w.warehouseName == p.parcelWaybillOriginLocation,
    )
      ? this.filteredWarehouses.filter(
          (w) => w.warehouseName == p.parcelWaybillOriginLocation,
        )[0].warehouseCode
      : "";
    return p.trackings.filter((t) => t.tpLastMile !== tpCode);
  }

  notPresentInTracking(trackings: ViewTrackings[], t: ViewTrackings) {
    return (
      trackings.filter((tr) => tr.trackingWarehouseCode == t.tpLastMile)
        .length == 0
    );
  }

  getWarehouseName(code: string) {
    return this.filteredWarehouses.filter((w) => w.warehouseCode == code)
      .length > 0
      ? this.filteredWarehouses.filter((w) => w.warehouseCode == code)[0]
          .warehouseName
      : code;
  }

  getWarehouseNameComParcel(code: string | undefined) {
    return this.filteredWarehouses.filter((w) => w.warehouseCode == code)
      .length > 0
      ? this.filteredWarehouses.filter((w) => w.warehouseCode == code)[0]
          .warehouseName
      : null;
  }

  getWarehouseShortNameComParcel(code: string | undefined) {
    return this.filteredWarehouses.filter((w) => w.warehouseCode == code)
      .length > 0
      ? this.filteredWarehouses.filter((w) => w.warehouseCode == code)[0]
          .warehouseShortName
      : null;
  }

  getDealerName(code: string | undefined) {
    return this.filteredDealers.filter((d) => d.dealerCode == code).length > 0
      ? this.filteredDealers.filter((d) => d.dealerCode == code)[0].dealerName
      : null;
  }

  getCarrierName(code: string | undefined) {
    return this.allCarriers.filter((d) => d.carrierCode == code).length > 0
      ? this.allCarriers.filter((d) => d.carrierCode == code)[0].carrierName
      : code;
  }

  getTourRoutingCode(id: number | undefined) {
    return this.allTours.filter((t) => t.tourRoutingId == id).length > 0
      ? this.allTours.filter((t) => t.tourRoutingId == id)[0].tourRoutingCode
      : id;
  }

  isLast(list: any[], item: any) {
    if (!list || !list.length) return true;
    return list[list.length - 1] === item;
  }

  getComParcelsFiltered(p: ViewParcels): ComParcel[] {
    if (!p.comParcels) return [];
    // esclude quelli di tipo TRANSIT e ordina per sequence
    return p.comParcels
      .filter(
        (c) =>
          c.parcelComplementaryType !== "TRANSIT" &&
          c.parcelComplementaryStatus !== "MISROUTING",
      )
      .sort(
        (a, b) =>
          (a.parcelComplementarySequence ?? Number.MAX_SAFE_INTEGER) -
          (b.parcelComplementarySequence ?? Number.MAX_SAFE_INTEGER),
      );
  }

  isRowClickable(p: ViewParcels): boolean {
    if (p.showComParcels) {
      return false;
    }

    if (!this.canWithGeofencingTourBigOrder()) {
      return false;
    }

    return true;
  }

  async toggleAndLoadComParcels(p: ViewParcels) {
    // toggle visibilità: se già caricati, chiudi
    if (p.showComParcels) {
      p.showComParcels = false;
      return;
    }

    if (!this.canWithGeofencingTourBigOrder()) {
      p.showComParcels = false;
      return;
    }

    // il dettaglio si apre subito: durante il caricamento mostra lo spinner della riga
    p.showComParcels = true;

    // se già caricati (o in caricamento), basta mostrarli
    if (p.loadingComParcels || (p.comParcels && p.comParcels.length > 0)) {
      return;
    }

    // altrimenti fetch
    p.loadingComParcels = true;
    p.errorLoadingComParcels = false;
    this.http
      .get<ComParcel[]>(
        `${environment.apiUrl}/tracking/comParcels/${p.parcelCode}`,
      )
      .subscribe({
        next: (results) => {
          p.comParcels = results;
          // (p.comParcels || []).sort((a: ComParcel, b: ComParcel) => {
          //   const sa = a.parcelComplementarySequence ?? Number.MAX_SAFE_INTEGER;
          //   const sb = b.parcelComplementarySequence ?? Number.MAX_SAFE_INTEGER;
          //   return sa - sb;
          // });
          p.loadingComParcels = false;
        },
        error: (err) => {
          console.error("Errore caricamento comParcels", err);
          p.errorLoadingComParcels = true;
          p.comParcels = [];
          p.loadingComParcels = false;
        },
      });
  }

  hasAnyComParcelsOpen(): boolean {
    return this.filteredParcels.some((p) => p.showComParcels);
  }

  toggleAllComParcels() {
    // se almeno uno è aperto, chiudi tutto
    if (this.hasAnyComParcelsOpen()) {
      this.filteredParcels.forEach((p) => (p.showComParcels = false));
      this.showHideTrackings = false;
      return;
    }

    if (!this.canWithGeofencingTourBigOrder()) {
      return;
    }

    this.showHideTrackings = true;

    // le tappe delle righe non ancora caricate (né in caricamento) arrivano con una sola chiamata
    const toLoad = this.filteredParcels.filter(
      (p) =>
        !p.loadingComParcels && !(p.comParcels && p.comParcels.length > 0),
    );
    this.filteredParcels.forEach((p) => (p.showComParcels = true));
    if (toLoad.length === 0) {
      return;
    }

    toLoad.forEach((p) => {
      p.loadingComParcels = true;
      p.errorLoadingComParcels = false;
    });
    this.overviewParcelsService
      .searchComParcels<ComParcel>(toLoad.map((p) => p.parcelCode))
      .subscribe({
        next: (results) => {
          toLoad.forEach((p) => {
            // un collo assente dalla risposta non è visibile all'utente (o non esiste più)
            const comParcels = results[p.parcelCode];
            p.comParcels = comParcels ?? [];
            p.errorLoadingComParcels = !comParcels;
            p.loadingComParcels = false;
          });
        },
        error: (err) => {
          console.error("Errore caricamento comParcels", err);
          toLoad.forEach((p) => {
            p.comParcels = [];
            p.errorLoadingComParcels = true;
            p.loadingComParcels = false;
          });
        },
      });
  }

  statusCircleClass(status?: string) {
    const s = (status || "").toUpperCase();
    if (s === "EXECUTED") return "done";
    if (s === "IN_PROGRESS") return "in-progress";
    if (s === "UNKNOWN") return "warning";
    if (s === "ERROR" || s === "MISROUTING") return "error";
    return "empty";
  }

  getTextClassComParcels(status?: string) {
    const s = (status || "").toUpperCase();
    if (s === "IN_PROGRESS") return "light-blue-text";
    if (s === "EXECUTED") return "green-text";
    if (s === "UNKNOWN") return "yellow-text";
    if (s === "ERROR" || s === "MISROUTING") return "red-text";
    return "grey-text";
  }

  getStepClassComParcel(c: ComParcel) {
    const s = (c.parcelComplementaryStatus || "").toUpperCase();
    if (s === "EXECUTED") return "done";
    if (s === "IN_PROGRESS") return "in-progress";
    if (s === "UNKNOWN") return "warning";
    if (s === "ERROR" || s === "MISROUTING") return "error";
    return "empty";
  }

  // per convertire stringhe data a Date in caso servisse nel template
  toDate(d?: string | Date | null): Date | null {
    if (!d) return null;
    return d instanceof Date ? d : new Date(d);
  }

  getTransitStatus(sequence: number, p: ViewParcels): string {
    const transit = p.comParcels?.find(
      (c) =>
        c.parcelComplementaryType === "TRANSIT" &&
        c.parcelComplementarySequence === sequence,
    );
    return transit ? transit.parcelComplementaryStatus : "PLANNED";
  }

  getTransportStatus(sequence: number, p: ViewParcels): string {
    const transport = p.comParcels?.find(
      (c) =>
        c.parcelComplementaryType === "TRANSPORT" &&
        c.parcelComplementarySequence === sequence,
    );
    return transport ? transport.parcelComplementaryStatus : "PLANNED";
  }

  getLineClassByTransport(status: string): string {
    switch (status) {
      case "EXECUTED":
        return "done";
      case "IN_PROGRESS":
        return "in-progress";
      case "UNKNOWN":
        return "warning";
      case "ERROR":
        return "error";
      default:
        return "empty";
    }
  }

  getCircleClassByTransit(status: string): string {
    switch (status) {
      case "EXECUTED":
        return "done";
      case "IN_PROGRESS":
        return "in-progress";
      case "UNKNOWN":
        return "warning";
      case "ERROR":
        return "error";
      default:
        return "empty";
    }
  }

  lastTo(comParcels: ComParcel[]): string | undefined {
    if (!comParcels || comParcels.length === 0) return undefined;
    return comParcels[comParcels.length - 1].parcelComplementaryWarehouseTo;
  }

  lastDealerTo(comParcels: ComParcel[]): string | undefined {
    if (!comParcels || comParcels.length === 0) return undefined;
    return comParcels[comParcels.length - 1].parcelComplementaryDealerTo;
  }

  getOriginTransit(comParcels: ComParcel[]): ComParcel | null {
    return comParcels[0]?.parcelComplementaryType === "TRANSIT"
      ? comParcels[0]
      : null;
  }

  getFirstTransport(comParcels: ComParcel[]): ComParcel | undefined {
    return this.getOriginTransit(comParcels) ? comParcels[1] : comParcels[0];
  }

  getComParcelPairs(p: any) {
    const all = (p.comParcels ?? []).filter(
      (x: any) => x?.parcelComplementaryStatus !== "MISROUTING",
    );
    const parcels = all.slice(this.getOriginTransit(all) ? 2 : 1);

    const pairs: Array<{ transit: any | null; transport: any | null }> = [];

    let i = 0;
    while (i < parcels.length) {
      const current = parcels[i];

      // Caso 1: TRANSIT
      if (current?.parcelComplementaryType === "TRANSIT") {
        const transit = current;

        // Se subito dopo c'è un TRANSPORT, lo abbino
        const next = parcels[i + 1];
        const transport =
          next?.parcelComplementaryType === "TRANSPORT" ? next : null;

        pairs.push({ transit, transport });

        i += transport ? 2 : 1;
        continue;
      }

      // Caso 2: TRANSPORT senza TRANSIT prima (gestione "sfasamenti")
      if (current?.parcelComplementaryType === "TRANSPORT") {
        pairs.push({ transit: null, transport: current });
        i += 1;
        continue;
      }

      // Caso 3: altro tipo -> skip
      i += 1;
    }

    return pairs;
  }

  hasErrorBranch(pairIndex: number, p: any): boolean {
    const nextPair = this.getComParcelPairs(p)[pairIndex + 1];
    return nextPair?.transport?.parcelComplementaryStatus === "ERROR";
  }

  typeIconRow(c: ComParcel): string[] {
    const t = (c.parcelComplementaryType || "").toUpperCase();
    const s = (c.parcelComplementaryStatus || "").toUpperCase();

    let icon = t === "TRANSIT" ? "fa-warehouse" : "fa-truck";

    let color = "grey-text";
    if (s === "EXECUTED") color = "green-text";
    else if (s === "IN_PROGRESS") color = "light-blue-text";
    else if (s === "ERROR") color = "red-text";
    else if (s === "UNKNOWN") color = "yellow-text";
    else if (s === "MISROUTING") {
      color = "red-text";
      icon = "fa-triangle-exclamation";
    }

    return ["fa", icon, color];
  }

  statusCircleClassRow(status?: string) {
    const s = (status || "").toUpperCase();
    if (s === "EXECUTED") return "done";
    if (s === "IN_PROGRESS") return "in-progress";
    if (s === "UNKNOWN") return "warning";
    if (s === "ERROR" || s === "MISROUTING") return "error";
    return "empty";
  }

  openUpdateComParcelModal(c: ComParcel) {
    this.selectedComParcel = c;
    this.editFormUpdateComParcel = {
      parcelComplementaryCarrierCode: c.parcelComplementaryCarrierCode || "",
    };
    this.showUpdateComParcelModal = true;

    // Colli aggiornati dalla modifica "per bolla": stessa bolla e stessa sequenza dell'evento
    this.waybillCountRequest?.unsubscribe();
    this.numberParcelsOfWaybill = null;
    this.waybillCountRequest = this.overviewParcelsService
      .getComParcelWaybillParcelsCount(c.parcelComplementaryId)
      .subscribe({
        next: (res) => (this.numberParcelsOfWaybill = res.parcelsCount),
        error: (err) =>
          console.error("Errore nel conteggio dei colli della bolla:", err),
      });
  }

  // Colli che giustifica ('justifiable': consegnati in ritardo o non consegnati) o note ('all') modificano
  // "per bolla": li conta il backend sull'intera bolla, indipendentemente da filtri e pagina
  private loadWaybillParcelsCount(
    parcel: ViewParcels,
    scope: "justifiable" | "all",
  ): void {
    this.waybillCountRequest?.unsubscribe();
    this.numberParcelsOfWaybill = null;
    if (parcel.isOrphan || !parcel.parcelCode) {
      return;
    }
    this.waybillCountRequest = this.overviewParcelsService
      .getWaybillParcelsCount(parcel.parcelCode)
      .subscribe({
        next: (res) =>
          (this.numberParcelsOfWaybill =
            scope === "justifiable"
              ? res.justifiableParcelsCount
              : res.parcelsCount),
        error: (err) =>
          console.error("Errore nel conteggio dei colli della bolla:", err),
      });
  }

  closeUpdateComParcelModal() {
    this.showUpdateComParcelModal = false;
    this.selectedComParcel = null;
  }

  updateComParcel(allComByWaybill: boolean) {
    if (!this.selectedComParcel) return;

    const updatedParcel = {
      ...this.selectedComParcel,
      parcelComplementaryCarrierCode:
        this.editFormUpdateComParcel.parcelComplementaryCarrierCode,
    };

    this.http
      .put(
        `${environment.apiUrl}/tracking/comParcel/${allComByWaybill}`,
        updatedParcel,
      )
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.refreshParcels();
          this.closeUpdateComParcelModal();
          this.notificationService.success("Vettore aggiornato con successo!");
        },
        error: (err) => {
          this.isLoading = false;
          this.closeJustificationModalComParcel();
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        },
      });
  }

  isLastComParcel(c: ComParcel, list: ComParcel[]): boolean {
    var listFiltered: ComParcel[] = list.filter(
      (l) => l.parcelComplementaryStatus != "MISROUTING",
    );
    return listFiltered[listFiltered.length - 1] === c;
  }

  getParcelDetailStatusLabel(status: string | null | undefined): string {
    if (!status) return "";

    switch (status) {
      case "PREPARED":
        return ParcelDetailStatus.PREPARED;
      case "CLOSED":
        return ParcelDetailStatus.CLOSED;
      case "IN_TRIP_TO_TP":
        return ParcelDetailStatus.IN_TRIP_TO_TP;
      case "IN_TRIP":
        return ParcelDetailStatus.IN_TRIP;
      case "SUSPENDED":
        return ParcelDetailStatus.SUSPENDED;
      default:
        // se ti arriva già "Preparata" o qualcosa di imprevisto
        return status;
    }
  }

  getComParcelsNoMisrouting(p: ViewParcels): ComParcel[] {
    return (p.comParcels ?? []).filter(
      (c) => c.parcelComplementaryStatus !== "MISROUTING",
    );
  }

  onRestrictedMinutesChange(min: number): void {
    if (this.selectedParcel?.isRestrictedClient == "N") return;
    if (!this.editForm.parcelDeliveryDate) return;

    const clamped = Math.min(59, Math.max(0, Number(min)));
    this.restrictedMinutes = clamped;

    // Mantieni fissi YYYY-MM-DDTHH e cambia solo i minuti
    // parcelDeliveryDate è una stringa "YYYY-MM-DDTHH:mm"
    const base = this.editForm.parcelDeliveryDate.slice(0, 14); // "YYYY-MM-DDTHH:"
    this.editForm.parcelDeliveryDate = `${base}${this.pad2(clamped)}`;
  }

  private setRestrictedNowDeliveryDate(): void {
    const now = new Date();
    if (this.editForm.parcelDeliveryDate == null) {
      this.editForm.parcelDeliveryDate = this.formatDateForInput(now);

      this.restrictedMinutes = now.getMinutes();
    }
  }

  private pad2(n: number): string {
    return String(n).padStart(2, "0");
  }

  downloadPodDocument(waybillCode: string, waybillShipmentCode: string): void {
    this.downloadWaybillPod(waybillCode, waybillShipmentCode).subscribe({
      next: (response: any) => {
        const blob = new Blob([response], { type: "application/pdf" });
        const timestamp = new Date()
          .toISOString()
          .replace(/[:.]/g, "-")
          .substring(0, 19);
        const filename = `POD_${waybillCode}_${timestamp}.pdf`;

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        this.notificationService.success(
          `Download POD avviato per bolla ${waybillCode}`,
        );
      },
      error: (err) => {
        const message = this.errorHelperService.extractBackendMessage(err);
        this.notificationService.error(`Errore: ${message}`);
      },
    });
  }

  downloadWaybillPod(
    waybillCode: string,
    waybillShipmentCode: string,
  ): Observable<Blob> {
    const url = `${environment.apiUrl}/tracking/download-pod`;

    const requestBody = {
      waybillCode: waybillCode,
      waybillShipmentCode: waybillShipmentCode,
    };

    return this.http.post<Blob>(url, requestBody, {
      responseType: "blob" as "json",
    });
  }

  private formatCountdown(diffMs: number): string {
    const totalSeconds = Math.floor(diffMs / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${this.pad2(hours)}:${this.pad2(minutes)}:${this.pad2(seconds)}`;
  }

  openNoteModal(parcel: any) {
    this.selectedParcel = parcel;
    this.loadWaybillParcelsCount(parcel, "all");
    this.editFormNote = {
      parcelNote: parcel.parcelNote || "",
    };

    this.showNoteModal = true;
  }

  closeNoteModal() {
    this.showNoteModal = false;
    this.selectedParcel = null;
  }

  openCarrierMailModal(parcel: ViewParcels) {
    this.selectedParcel = parcel;
    this.showCarrierMailModal = true;
  }

  closeCarrierMailModal() {
    this.showCarrierMailModal = false;
    this.selectedParcel = null;
  }

  getCarrierSentEmailsList(emails?: string): string[] {
    if (!emails) return [];
    return emails
      .split(";")
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  }

  formatCarrierSentDate(date: any): string {
    return this.formatDate(date);
  }

  saveNote(allParcels: boolean) {
    this.isLoading = true;

    const payload = {
      parcelCode: this.selectedParcel?.parcelCode,
      parcelNote: this.editFormNote.parcelNote,
      parcelClientCode: this.selectedParcel?.parcelClientCode,
      parcelBrandCode: this.selectedParcel?.parcelBrandCode,
    };

    this.http
      .put(`${environment.apiUrl}/tracking/parcel/notes/${allParcels}`, payload)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.refreshParcels();
          this.closeNoteModal();
          this.notificationService.success("Nota aggiornata con successo!");
        },
        error: (err) => {
          this.isLoading = false;
          this.closeNoteModal();
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        },
      });
  }

  toggleJustificationsDropdown(): void {
    this.isJustificationsDropdownOpen = !this.isJustificationsDropdownOpen;
  }

  getFilteredJustifications() {
    if (!this.justificationSearchTerm) {
      return this.filteredJustifications;
    }

    return this.filteredJustifications.filter((j) =>
      j.justificationName
        ?.toLowerCase()
        .includes(this.justificationSearchTerm.toLowerCase()),
    );
  }

  clearJustificationSearch(): void {
    this.justificationSearchTerm = "";
  }

  selectJustification(justification: any): void {
    this.editFormJustification.parcelJustificationId =
      justification?.justificationId || null;

    this.isJustificationsDropdownOpen = false;
  }

  getSelectedJustificationName(): string | null {
    const selected = this.filteredJustifications.find(
      (j) =>
        j.justificationId === this.editFormJustification.parcelJustificationId,
    );

    return selected?.justificationName || null;
  }

  get isJustificationSent(): boolean {
    return this.selectedParcel?.parcelIsJustificationSent === "SENT";
  }

  openImportExcelModal() {
    this.showImportExcelModal = true;
    this.loadImportJustificationCodeGroups();
  }

  // Giustifiche utilizzabili dall'utente, già filtrate e ordinate dal backend (generiche per prime)
  private loadImportJustificationCodeGroups() {
    this.isLoadingJustificationCodes = true;
    this.importJustificationCodeGroups = [];

    this.http
      .get<AllowedJustificationsGroup[]>(
        `${environment.apiUrl}/tracking/justifications/allowed`,
      )
      .subscribe({
        next: (groups) => {
          this.isLoadingJustificationCodes = false;
          this.importJustificationCodeGroups = groups.map((g) => ({
            title: g.clientCode
              ? `Cliente ${g.clientName ?? g.clientCode}`
              : "Generiche",
            codes: g.justifications.map((j) => ({
              code: j.justificationCode,
              name: j.justificationName.startsWith(`${j.justificationCode} - `)
                ? j.justificationName.substring(j.justificationCode.length + 3)
                : j.justificationName,
            })),
          }));
        },
        error: (err) => {
          this.isLoadingJustificationCodes = false;
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(
            `Errore nel caricamento dei codici giustifica: ${message}`,
          );
        },
      });
  }

  downloadImportJustificationsTemplate() {
    const wb = XLSX.utils.book_new();

    const templateSheet = XLSX.utils.aoa_to_sheet([
      IMPORT_JUSTIFICATIONS_HEADERS,
    ]);
    templateSheet["!cols"] = [{ wch: 20 }, { wch: 20 }, { wch: 60 }];
    XLSX.utils.book_append_sheet(wb, templateSheet, "Giustifiche");

    // Il backend legge solo il primo foglio: il secondo è solo un promemoria dei codici
    const codesSheet = XLSX.utils.aoa_to_sheet([
      ["Gruppo", "Codice giustifica", "Giustifica"],
      ...this.importJustificationCodeGroups.flatMap((g) =>
        g.codes.map((c) => [g.title, c.code, c.name]),
      ),
    ]);
    codesSheet["!cols"] = [{ wch: 45 }, { wch: 18 }, { wch: 45 }];
    XLSX.utils.book_append_sheet(wb, codesSheet, "Codici");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    FileSaver.saveAs(blob, "modello_import_giustifiche.xlsx");
  }

  closeImportExcelModal() {
    this.showImportExcelModal = false;
    this.selectedExcelFile = null!;
  }

  onFileSelected(event: any) {
    if (event.target.files.length > 0) {
      this.selectedExcelFile = event.target.files[0];
    }
  }

  importExcelJustifications() {
    this.isLoading = true;
    const formData = new FormData();
    formData.append("file", this.selectedExcelFile);

    this.http
      .post(
        `${environment.apiUrl}/tracking/import-excel-justifications`,
        formData,
      )
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.applyFilters();
          this.closeImportExcelModal();
          this.notificationService.success("Excel importato con successo");
        },
        error: (err) => {
          this.isLoading = false;
          this.closeImportExcelModal();
          const message = this.errorHelperService.extractBackendMessage(err);
          this.notificationService.error(`Errore: ${message}`);
        },
      });
  }
}
